import { createFileRoute, notFound } from "@tanstack/react-router";
import compareStyles from "../styles/compare.css?url";
import { withStylesheet } from "../lib/head";
import { CompareHub } from "../platform/compare/compare-pages";
import { loadCompareHub } from "../platform/compare";
import { platformPageHead, platformShellFrom } from "../platform/head";

/** /compare: how Drate compares with the platforms creators ask about (Drate's host only). */
export const Route = createFileRoute("/compare/")({
  loader: async () => {
    const page = await loadCompareHub();
    if (!page) throw notFound();
    return page;
  },
  head: ({ matches, loaderData }) =>
    loaderData
      ? withStylesheet(
          platformPageHead(platformShellFrom(matches), {
            pathname: "/compare",
            title: "Creator monetization platforms compared | Drate",
            description:
              "Patreon, Substack, Ko-fi, Skool, Stan Store and more, next to Drate: what each creator platform takes, and whether you get your own domain and app.",
            structuredData: loaderData.structuredData,
          }),
          compareStyles,
        )
      : {},
  component: () => <CompareHub page={Route.useLoaderData()} />,
});
